# ---
# Платежная информация организации
# ---
App.BillingInfo = DS.Model.extend
  balance                     : DS.attr 'number'
  pay_day                     : DS.attr 'number'
  debt_detected               : DS.attr 'date'
  organization_name           : DS.attr 'string'
  blocked                     : DS.attr 'boolean'
  block_date                  : DS.attr 'date'
  next_checkout_date          : DS.attr 'date'

  tariff_restrictions         : DS.attr 'mixed'

  has_extra_fees              : DS.attr 'boolean'

  bank_details                : DS.attr 'mixed'

  # Внешние связи
  organization                : DS.belongsTo 'organization', async: true

  # Согласие на использование платных услуг
  paywall_accepted:     DS.attr 'boolean'
  paywall_warning:      DS.attr 'boolean'
  paywall_expired:      DS.attr 'boolean'
  paywall_deadline:     DS.attr 'date'

  estimated_block_date: DS.attr 'date'
  trial_active:         DS.attr 'boolean'
  trial_expires_at:     DS.attr 'date'
  pending_invoices_sum: DS.attr 'number'
  has_free_tariff:      DS.attr 'boolean'

  absoluteBalance: (->
    Math.abs @get('balance')
  ).property('balance')

  beforePaywallDeadline: (->
    @get('paywall_deadline') and !@get('paywall_expired')
  ).property(
    'paywall_deadline',
    'paywall_expired')

  afterPaywallDeadline: Em.computed.not('beforePaywallDeadline')

  # принять paywall
  acceptPaywall: ->
    if @get('paywall_accepted')
      Em.RSVP.resolve()
    else
      @nonRESTAction('POST', 'paywall')

  # принять paywall
  setBankDetails: (bank_details)->
    @nonRESTAction('PUT', 'bank_details', bank_details: bank_details)
    .then
    @reload()
